import React from 'react';
import { SvgIconProps } from '@mui/material';

export const MailIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="28"
        height="22"
        viewBox="0 0 28 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2.44444 2.42857L11.2671 9.01714L11.27 9.02C12.2493 9.73 12.739 10.0857 13.2763 10.2229C13.751 10.3443 14.249 10.3443 14.7237 10.2229C15.261 10.0857 15.7521 9.73 16.7343 9.01714C16.7343 9.01714 22.3922 4.72286 25.5556 2.42857M1 16.4286V5.57143C1 3.97143 1 3.17143 1.31489 2.56C1.59222 2.02143 2.03278 1.58571 2.57733 1.31143C3.19556 1 4.00444 1 5.62222 1H22.3778C23.9956 1 24.8044 1 25.4212 1.31143C25.9658 1.58571 26.4078 2.02143 26.6851 2.56C27 3.17 27 3.97 27 5.56714V16.4343C27 18.0314 27 18.8286 26.6851 19.44C26.4076 19.9777 25.9652 20.4147 25.4212 20.6886C24.8044 21 23.997 21 22.3821 21H5.61789C4.003 21 3.19411 21 2.57733 20.6886C2.03378 20.4147 1.59185 19.9776 1.31489 19.44C1 18.8286 1 18.0286 1 16.4286Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default MailIcon;
